import { create } from 'zustand';
import { ICategory, IClient, IState, IUser, IPlans, ICoupon } from '../@types/system';

export interface useStateProps {
  token: string | null;
  user: IUser;
  clients: IClient[];
  states: IState[];
  selectState: IState;
  userType: string[];
  plans: IPlans[];
  coupons: ICoupon[];
  categories: ICategory[];
  users: IUser[];

  setToken: (token: string) => void;
  setUser: (user: IUser) => void;
  setUsers: (user: IUser[]) => void;
  setClients: (user: IClient[]) => void;
  setSelectState: (state: IState) => void;
  setCoupons: (coupons: ICoupon[]) => void;
  setCategories: (categories: ICategory[]) => void;
  setPlans: (categories: IPlans[]) => void;

  clearLogin: () => void;
}

export const useStore = create<useStateProps>((set) => {
  return {
    token: null,
    user: {} as IUser,
    clients: [],
    users: [],
    states: [],
    coupons: [],
    categories: [],
    plans: [],
    selectState: {} as IState,
    userType: ['ADMIN', 'MANAGER', 'USER', 'SUPERADMIN', 'SELLER', 'EVENTS_ADMIN'],

    setToken: (token) => set({ token }),
    setUser: (user) => set({ user }),
    setUsers: (users) => set({ users }),
    setClients: (clients) => set({ clients }),
    setPlans: (plans) => set({ plans }),
    setSelectState: (selectState) => set({ selectState }),
    setCoupons: (coupons) => {
      set({ coupons });
    },
    setCategories: (categories) => set({ categories }),

    clearLogin: () =>
      set({
        token: null,
        user: {} as IUser,
      }),
  };
});
